import { Common, color } from '@stockbit/ui';
import Image from 'global/Image';
import { useEffect } from 'react';
import If from 'global/ErrorHandlers/If';
import tradingStore from 'lib/stores/trading';
import create from 'zustand';
import Link from 'next/link';

import { clevertapSecuritiesTradingPinViewed } from 'lib/analytics/securities';
import { LoginInfoDivider, LoginTradingModalContainer } from './styled';
import {
  AuthModalLoading,
  LoginInputPin,
  VirtualTradingButton,
} from './components';
import { AuthModalProps, AuthModalType } from './types';
import useAuthModalStore from './store';
import useLogin from './hooks/useLogin';

const { Flex, Text } = Common;

const useTradingStore = create(tradingStore);

export default function LoginTradingModal({ visible }: AuthModalProps) {
  const { resetErrorCode } = useTradingStore();
  const { closeModal } = useAuthModalStore();

  const { errorMsg, setErrorMsg, loading, setLoading, onLogin } = useLogin();

  const closeLoginModal = () => {
    resetErrorCode();
    setErrorMsg('');
    closeModal();
  };

  useEffect(() => {
    setErrorMsg('');

    if (visible) {
      clevertapSecuritiesTradingPinViewed();
    }
  }, [visible]);

  return (
    <LoginTradingModalContainer
      data-cy="login-trading-modal"
      visible={visible}
      centered
      width={500}
      onCancel={closeLoginModal}
    >
      <Flex direction="column" justify="center" align="center">
        <Image
          className="illustration"
          alt="securities-lock"
          src="icon/securities-lock.svg"
        />

        <If condition={loading}>
          <AuthModalLoading />
        </If>

        <If condition={!loading}>
          <Text size="24px" family="bold" mt="48px" mb="24px">
            Masukkan PIN Trading
          </Text>

          <LoginInputPin onLogin={onLogin} errorMsg={errorMsg} />

          <Link href="/securities/forgotpin">
            <Flex onClick={closeLoginModal}>
              <Text
                size="14px"
                family="bold"
                color={color.primary}
                mt="24px"
                mb="48px"
              >
                <a data-cy="auth-modal-forgot-pin">Lupa Pin?</a>
              </Text>
            </Flex>
          </Link>

          <Flex width="100%" justify="space-between" align="center" mb="48px">
            <LoginInfoDivider />
            <Text family="bold" color={color.midgray}>
              Or
            </Text>
            <LoginInfoDivider />
          </Flex>

          <VirtualTradingButton
            title="Virtual Trading"
            type={AuthModalType.LOGIN}
            setLoading={setLoading}
          />
        </If>
      </Flex>
    </LoginTradingModalContainer>
  );
}
